import { DetailDescriptionDataSource } from '../DetailDescriptionDataSource';
import { AssetType } from '../../../api/models/Shared.types';
import { Backend } from '../../../api/Backend';
import { ISeriesDetail } from '../../../api/models/AndromeTV.types';
import { IDetailDescription } from '../detail.types';

export class EpgSeriesDetailDescriptionDataSource extends DetailDescriptionDataSource {
  private series: ISeriesDetail;
  constructor(seriesId: string | undefined, seriesAsset: ISeriesDetail, backend: Backend) {
    super(seriesId, AssetType.SERIES, backend);
    this.series = seriesAsset;
  }

  /**
   *
   * @returns {Promise<IDetailDescription>}
   */
  override load(): Promise<IDetailDescription> {
    const res: IDetailDescription = {
      title: this.series.title,
      synopsis: this.series.longSynopsis
        ? this.series.longSynopsis
        : this.series.shortSynopsis
        ? this.series.shortSynopsis
        : '',
      ageRating: undefined,
      score: undefined,
      metaInformation: undefined,
      expire: undefined,
      subscription: undefined,
      pricing: undefined,
      resolution: undefined,
      secondaryMetaInfo: undefined,
      credits: undefined,
      parentalControlIcons: undefined,
      bookmarkPercentage: undefined,
    };
    return Promise.resolve(res);
  }
}
